import { Categorie, LigneEmploye, RepartitionCellule } from '../types';

/**
 * Fonction dominante dérivée d'une répartition : les parts sont agrégées par
 * catégorie racine (les sous-groupes remontent à leur parent), la plus forte
 * l'emporte.
 */
export function deriverFonction(
  rep: RepartitionCellule | null | undefined,
  categories: Categorie[]
): string | null {
  if (!rep || categories.length === 0) return null;
  const parId = new Map(categories.map((c) => [c.id, c]));
  const parRacine = new Map<number, number>();
  for (const [idStr, taux] of Object.entries(rep.lignes)) {
    const cat = parId.get(Number(idStr));
    if (!cat) continue;
    const racine = cat.parentId ?? cat.id;
    parRacine.set(racine, (parRacine.get(racine) ?? 0) + Number(taux));
  }
  let meilleurId: number | null = null;
  let max = -1;
  for (const [id, somme] of parRacine) {
    if (somme > max) { max = somme; meilleurId = id; }
  }
  return meilleurId != null ? parId.get(meilleurId)?.nom ?? null : null;
}

/**
 * Fonction affichée pour un·e employé·e : dérivée de la répartition en vigueur
 * au mois de référence ; à défaut, la catégorie contractuelle importée.
 */
export function fonctionEffective(
  ligne: LigneEmploye,
  moisRef: number,
  categories: Categorie[]
): { nom: string; derive: boolean } {
  const rep = ligne.mois[moisRef - 1]?.repartition ?? null;
  const nom = deriverFonction(rep, categories);
  return nom ? { nom, derive: true } : { nom: ligne.categorie, derive: false };
}
